import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../../../_hooks/useClientId';
import { PortfolioDTO } from '../../../../../RiskToleranceWorkflow/api/useSubmitAnswersMutation';

export interface OrionRiskIntelligenceWorkflowSendSurveyResponse {
  detail: {
    riskScore: string;
    id: string;
  };
}

const saveOrionRiskIntelligenceWorkflow = (clientId: number) => (
  detail: OrionRiskIntelligenceWorkflowSendSurveyResponse['detail'],
): Promise<PortfolioDTO> => {
  return authFetch(
    urlWithParams('/Consumer/RiskToleranceWorkflowUpdate/PostOriRtqResponse', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions(detail, true) },
  );
};

export const useOrionRiskIntelligenceWorkflowMutation = () => {
  const clientId = useClientId();

  return useMutation(saveOrionRiskIntelligenceWorkflow(clientId));
};
